// Copyright (c) 2020 Deere & Company

import SapStatus, {getDefaultState} from '../../shared/state/sap-Status';
import actions from '../../shared/actions-list';

const updateSapStatus = (state, action) =>
    SapStatus.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_SAP_STATUS]: updateSapStatus

    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/app/reducers/sap-status.js